import { PageContainer } from "@equinor/e-procurement-portal-and-ts-portal-front-end-components";
import { Paper } from "@mui/material";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { ForbiddenError } from "../../../../errors/ForbiddenError";
import { NewTermForm } from "./-internal_components/NewTermForm";

const NewTerm: React.FC = () => {
  const { t } = useTranslation();

  return (
    <PageContainer maxWidth="md" showBackButton title={t("terms.newTerm")}>
      <Paper
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          maxWidth: "100%",
          padding: "24px",
        }}
      >
        <NewTermForm />
      </Paper>
    </PageContainer>
  );
};

export const Route = createFileRoute(
  "/_private/vsupplierregistration/terms/new",
)({
  beforeLoad({ context }) {
    if (context.auth.user?.roles_names.includes("Term - Create")) {
      return;
    }

    throw new ForbiddenError();
  },
  component: NewTerm,
});
